import { Colors } from "../../themes/colors";

export const XMarkIcon = ({ color = Colors.neutral_600, className, size = 22 }) => (
  <svg
    className={className}
    fill="none"
    height={size}
    stroke={color}
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
);
